export async function resolveImageUrl(imagePath, importPatchNoteImageModule = importPatchNoteImage) {
    const match = imagePath.match(/^\/([^/]+)\/([^/]+)\.([^.]+)$/);
    if (match == null) throw new Error(`Invalid patch note image path: ${imagePath}`);
    const [, version, name, extension] = match;
    const module = await importPatchNoteImageModule(version, name, extension);
    return module.default;
}
async function importPatchNoteImage(version, name, extension) {
    const module = await import(`@static/images/patch_notes/${version}/${name}.${extension}`);
    return {
        default: module.default
    };
}
